import { render } from "./ContactRequestView.vue?vue&type=template&id=4444130c"
import script from "./ContactRequestView.vue?vue&type=script&lang=js"
export * from "./ContactRequestView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__